'use strict';

/** @global window, document */

import {render, unmountComponentAtNode} from 'react-dom';
import ActorsFromPost     from './../../../components/Blog/ActorsFromPost';
import React              from 'react';
import PjaxWrapper        from './../../../utils/PjaxWrapper';
import SinglePostVideo    from './../../../components/Magazine/BlogArticle/SinglePostVideo';
import HistoryStateHelper from './../../../utils/HistoryStateHelper';
import PostShare          from './../../../components/Magazine/PostShare';
import UrlHelper          from './../../../utils/UrlHelper';
import Translations       from '../../../utils/Translations';
import {throttle}         from '../../../utils/CommonUtils';

/**
 * @param {Element} el
 * @return {boolean}
 * @private
 */
const _isElementInViewport = function(el) {
	try {
		const rect               = el.getBoundingClientRect(),
		      minimumVisiblePart = 4;

		return (
			rect.top <= rect.height / minimumVisiblePart         // when at least 1/3 or post is visible from upper side
			&& rect.bottom >= rect.height / minimumVisiblePart   // and same from bottom side
		);
	} catch {
		return false;
	}
};

/**
 * Replace URL on other post scroll
 * @private
 */
const _onScroll = function() {
	const nodes = document.querySelectorAll('[data-link]');

	for (let i = 0; i < nodes.length; i++) {
		if (_isElementInViewport(nodes[i])) {
			const link = nodes[i].getAttribute('data-link');

			if (window.location.pathname.indexOf(link) === -1) {
				HistoryStateHelper.setValue(null, null, nodes[i].getAttribute('data-title'), link);
			}
		}
	}
};

/**
 * @param {Element} node
 */
const renderActorsFromPost = function(node) {
	// parse models data
	const models  = JSON.parse(node.querySelector('.girls-from-this-post__data').innerHTML),
	      element = node.parentNode;

	// render components
	render(<ActorsFromPost models={models} title={Translations.get('TVBlogOurGirls') + ' ' + Translations.get('TVBlogThisPost')} />, element);
	PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(element));
};

/**
 * @param {Element} postNode
 */
const renderVideoPlayers = function(postNode) {
	const video    = postNode.getAttribute('data-video'),
	      preview  = postNode.getAttribute('data-preview'),
	      autoPlay = postNode.hasAttribute('data-autoplay'),
	      element  = postNode.querySelector('.magazine-blog-post--single__image-wrapper');

	// render components
	render(<SinglePostVideo video={video} preview={preview} autoPlay={autoPlay} />, element);
	PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(element));
};

const renderSocialShares = function(node) {
	const article = node.parentNode.classList.contains('-is-supplementary')
			? node.parentNode
			: node.parentNode.parentNode,
	      link    = UrlHelper.getBaseUriAsDesktopSite('https://' + window.location.host) + article.getAttribute('data-link');

	const title = article.getAttribute('data-title');
	const id    = article.getAttribute('data-id');

	// render components
	render(<PostShare url={link} id={id} title={title} />, node);
	PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(node));
};

const onReady = function() {
	const actorsFromPosts = document.querySelectorAll('.girls-from-this-post'),
	      postsWithVideo  = document.querySelectorAll('.-has-video'),
	      shares          = document.querySelectorAll('.magazine-blog-post--single__share'),
	      scrollHandler   = throttle(_onScroll, 200);

	for (let i = 0; i < actorsFromPosts.length; i++) {
		renderActorsFromPost(actorsFromPosts[i]);
	}
	for (let j = 0; j < postsWithVideo.length; j++) {
		renderVideoPlayers(postsWithVideo[j]);
	}
	for (let c = 0; c < shares.length; c++) {
		renderSocialShares(shares[c]);
	}

	// listen for scroll & resize
	window.addEventListener('scroll', scrollHandler);
	window.addEventListener('resize', scrollHandler);
	PjaxWrapper.addUnloadFunc(() => {
		window.removeEventListener('scroll', scrollHandler);
		window.removeEventListener('resize', scrollHandler);
	});
};

function run() {
	if (['interactive', 'complete'].indexOf(document.readyState) !== -1) {
		onReady();
	} else {
		window.addEventListener('DOMContentLoaded', onReady);
	}
}

export {run};
